<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="60"
  >
    <v-btn
      class="mr-3"
      elevation="4"
      style="border-width: 2px;"
      fab
      small
      outlined
      color="blue"
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-spacer />

    <!-- Botão de Configurações
    <v-menu
      v-model="menu"
      :close-on-content-click="config(visivel)"
      offset-y
      transition="scale-transition"
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>

      <v-card width="300">
        <dashboard-core-settings v-model="expandOnHover" />
      </v-card>
    </v-menu> -->

    <!-- Botão de Avisos -->
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            :content="unreadNotificationsCount"
            :value="unreadNotificationsCount > 0"
            color="red"
            overlap
          >
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list
        class="notification-list pa-0"
        :tile="false"
        flat
        nav
      >
        <v-list-item-group
          v-if="avisos.length >= 0"
          dense
        >
          <app-bar-item
            v-for="(aviso, index) in avisos"
            :key="index"
            :aviso="aviso"
            @click="visualizar(aviso)"
          />
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import { VHover, VListItem, VListItemContent, VListItemTitle } from 'vuetify/lib'
  import { mapState, mapMutations } from 'vuex'
  import avisosService from '../../../../services/avisosservice'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      // DashboardCoreSettings: () => import('../../components/core/Settings'),
      AppBarItem: {
        props: {
          aviso: Object,
        },
        render (h) {
          return h(
            VHover,
            {
              scopedSlots: {
                default: ({ hover }) =>
                  h(
                    VListItem,
                    {
                      class: {
                        'black--text': !hover,
                        'white--text secondary elevation-12': hover,
                      },
                      props: {
                        activeClass: '',
                        dark: hover,
                        link: true,
                      },
                      on: {
                        click: () => this.$emit('click', this.aviso),
                      },
                    },
                    [
                      h(VListItemContent, [
                        h(
                          VListItemTitle,
                          { class: 'title-perso' },
                          this.aviso.titulo || 'título',
                        ),
                      ]),
                    ],
                  ),
              },
            },
          )
        },
      },

    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      avisos: [],
      profile: [
        {
          title: 'Perfil',
          to: '/editar-perfil',
        },
      ],
      menu: false,
      expandOnHover: false,
      visivel: false,
      intervaloAvisos: null,
    }),

    computed: {
      ...mapState(['drawer']),
      unreadNotificationsCount () {
        return this.avisos.filter(aviso => !aviso.visualizado).length
      },
      computedOnLine () {
        return navigator.onLine
      },
    },

    mounted () {
      this.findAvisos()

      this.intervaloAvisos = setInterval(() => {
        this.findAvisos()
      }, 1 * 60 * 1000)
    },

    beforeDestroy () {
      if (this.intervaloAvisos) {
        clearInterval(this.intervaloAvisos)
      }
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      async findAvisos () {
        this.loading = true

        try {
          const resposta = await avisosService.listarAvisos(localStorage.chaveativacao, true)
          const data = resposta.data.avisos

          if (Array.isArray(data) && data.length > 0) {
            this.avisos = data.map(aviso => ({
              id: aviso.id,
              titulo: aviso.titulo,
              produtorId: aviso.produtorId,
              visualizado: aviso.visualizado,
            }))
          } else {
            this.avisos = []
          }
        } catch (e) {
          console.error('Erro ao buscar avisos:', e)
        } finally {
          this.loading = false
          // const agora = new Date()
          // const horaAtual = agora.toLocaleTimeString() // formato hh:mm:ss
          // console.log('Hora atual:', horaAtual)
        }
      },
      visualizar (aviso) {
        aviso.visualizado = true
        this.$forceUpdate()

        this.$router.push({ name: 'Aviso', params: { idAviso: aviso.id, produtorId: aviso.produtorId } }).catch(() => {})
      },
      config (visivel) {
        this.visivel = visivel
        this.$emit('input', visivel)
      },
    },
  }

</script>

<style>
.notification-read {
  /* background: url('https://cdn.materialdesignicons.com/5.4.55/font/css/materialdesignicons.css') no-repeat center center; */
  background-size: contain;
  padding-left: 30px;
  background-color: #e0f7fa;
}
.title-perso {
  font-size: 10px !important;
  padding-left: 0px;
}
.notification-list {
  max-height: 200px !important;   /* altura máxima com scroll */
  overflow-y: auto !important;    /* rolagem vertical */
  max-width: 200px !important;    /* largura máxima */
  width: 100% !important;         /* largura responsiva até max-width*/
  box-sizing: border-box !important;
}
.notification-list .v-list-item {
  padding-top: 1px !important;
  padding-bottom: 0px !important;
  padding-inline-start: 35px !important;
  padding-right: 10px !important;
}

</style>
